import { AbstractControlOptions, FormGroup } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import { Parameters, PledgeRead } from '../../definition/interface/Pledge';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<any> = {
      scpiRentPaymentIban: this.formBuilder.group({
        accountId: [parameters?.scpiRentPaymentIban?.accountId || null],
        ownerIds: [parameters?.scpiRentPaymentIban?.ownerIds || []],
        id: [parameters?.scpiRentPaymentIban?.id || null],
        holder: [
          parameters?.scpiRentPaymentIban?.holder || null,
          // Validators.required,
        ],
        bic: [
          parameters?.scpiRentPaymentIban?.bic || null,
          // Validators.required,
        ],
        iban: [
          parameters?.scpiRentPaymentIban?.iban || null,
          // Validators.required,
        ],
        bankName: [
          parameters?.scpiRentPaymentIban?.bankName || null,
          // Validators.required,
        ],
        ibanTest: [
          parameters?.scpiRentPaymentIban?.iban || null,
          // Validators.required,
        ],
      }),
    };
    return this.formBuilder.group(formConfig, options);
  }
  get scpiRentPaymentIban() {
    return this.form.get('scpiRentPaymentIban') as FormGroup;
  }
  extract() {
    return { ...this.form.value };
  }
}
